var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductDetailPageComponent',_vm._b({on:{"unauthenticatedProductClick":_vm.unauthenticatedProductClick,"addToCart":function($event){return _vm.addToCart($event)}}},'ProductDetailPageComponent',_vm.productDetailPageComponentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }